/** Stroke icons from the canvas sidebar (design/canvas/_shell.py ICONS), 16 by 16 viewBox. */
const PATHS: Record<string, string> = {
  upload: 'M8 11V3 M4.5 6.5 8 3l3.5 3.5 M2.5 11.5v1a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-1',
  grid: 'M2.5 2.5h4.5v4.5h-4.5z M9 2.5h4.5v4.5H9z M2.5 9h4.5v4.5h-4.5z M9 9h4.5v4.5H9z',
  folder: 'M2.5 4.5a1 1 0 0 1 1-1h3l1.5 1.5h4.5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1z',
  archive: 'M2.5 3h11v3h-11z M3.5 6v6a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V6 M6.5 9h3',
  clock: 'M8 2.5a5.5 5.5 0 1 1 0 11a5.5 5.5 0 0 1 0-11z M8 5v3l2 1.5',
  list: 'M3 4.5h10M3 8h10M3 11.5h7',
  film: 'M2.5 3h11v10h-11z M5.5 3v10M10.5 3v10M2.5 6h3M10.5 6h3M2.5 10h3M10.5 10h3',
  music: 'M6 12.5V4l7-1.5V11 M4.5 11a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3z M11.5 9.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3z',
  export: 'M8 3v7 M5 6l3-3 3 3 M3 10v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2',
  check: 'M8 2.5a5.5 5.5 0 1 1 0 11a5.5 5.5 0 0 1 0-11z m-2.5 5.5 1.8 1.8L10.5 6.3',
  enter: 'M12.5 3.5v4a2 2 0 0 1-2 2h-7 M6 7l-2.5 2.5L6 12',
  calendar: 'M2.5 3.5h11v10h-11z M2.5 7h11M5.5 2v3M10.5 2v3',
  send: 'M13 3 2.5 7.5l4.5 1.5L8.5 13.5z',
  tag: 'M2.5 8.5V3.5a1 1 0 0 1 1-1h5l5 5-5.5 5.5z M5.5 4.5a1 1 0 1 0 0 2a1 1 0 0 0 0-2z',
  search: 'M7 2.5a4.5 4.5 0 1 1 0 9a4.5 4.5 0 0 1 0-9z m3.5 8 3 3',
  // An eight-tooth cog round a hole; the spoked version read as a sun.
  gear: 'M6.38 3.27 L6.95 3.11 L6.92 1.49 L9.08 1.49 L9.05 3.11 L10.2 3.51 L10.71 3.8 L11.84 2.63 L13.37 4.16 L12.2 5.29 L12.73 6.38 L12.89 6.95 L14.51 6.92 L14.51 9.08 L12.89 9.05 L12.49 10.2 L12.2 10.71 L13.37 11.84 L11.84 13.37 L10.71 12.2 L9.62 12.73 L9.05 12.89 L9.08 14.51 L6.92 14.51 L6.95 12.89 L5.8 12.49 L5.29 12.2 L4.16 13.37 L2.63 11.84 L3.8 10.71 L3.27 9.62 L3.11 9.05 L1.49 9.08 L1.49 6.92 L3.11 6.95 L3.51 5.8 L3.8 5.29 L2.63 4.16 L4.16 2.63 L5.29 3.8z M8 5.8a2.2 2.2 0 1 1 0 4.4a2.2 2.2 0 0 1 0-4.4z',
  lines: 'M3 4.5h10M3 8h10M3 11.5h6',
  erase: 'M9 3.2 13 7.2 7.7 12.5H4.5L2.8 10.8a1 1 0 0 1 0-1.4z M6.2 6 10.2 10 M7.7 12.5H13.5',
  trash: 'M3 4.5h10 M6.5 4.5V3h3v1.5 M4.5 4.5l.5 8a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1l.5-8 M6.5 7v4M9.5 7v4',
  redo: 'M13 8A5 5 0 1 1 11.5 4.5 M11.5 2v3h-3',
  shuffle: 'M2.5 4.5h2.5l6 7h2.5 M11.5 9.5l2 2-2 2 M2.5 11.5h2.5l1.6-1.9 M8.7 6.4l2.3-1.9h2.5 M11.5 2.5l2 2-2 2',
  dice: 'M3 3h10v10H3z M5.7 5.7h.1M10.3 5.7h.1M8 8h.1M5.7 10.3h.1M10.3 10.3h.1',
  save: 'M3 3h8.5L13 4.5V13H3z M5 3v3.5h5V3 M5 13V9h6v4',
  copy: 'M5.5 5.5h8v8h-8z M5.5 10.5h-2a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2',
  template: 'M2.5 2.5h11v3h-11z M2.5 7h4.5v6.5H2.5z M9 7h4.5v2.5H9z M9 11h4.5v2.5H9z',
  wand: 'M12.5 3.5 4 12 M10.5 2.5l.4 1.6L12.5 4.5l-1.6.4-.4 1.6-.4-1.6L8.5 4.5l1.6-.4z',
  plus: 'M8 3v10M3 8h10',
  globe: 'M8 2.5a5.5 5.5 0 1 1 0 11a5.5 5.5 0 0 1 0-11z M2.5 8h11 M8 2.5c1.5 1.5 2.3 3.4 2.3 5.5S9.5 12 8 13.5 M8 2.5C6.5 4 5.7 5.9 5.7 8s.8 4 2.3 5.5',
  bookmark: 'M4.5 2.5h7v11L8 11l-3.5 2.5z',
  pulse: 'M1.5 8h2.5l1.5-4 2.5 8 2-6.5 1 2.5h3.5',
  jitter: 'M1.5 8c1-1.6 2.2-1.6 3.2 0s2.2 1.6 3.2 0 M8.1 8c1-1.6 2.2-1.6 3.2 0s2.2 1.6 3.2 0',
  zoom: 'M7 2.5a4.5 4.5 0 1 1 0 9a4.5 4.5 0 0 1 0-9z m3.5 8 3 3 M5 7h4',
  dots: 'M8 3.2h.01M8 8h.01M8 12.8h.01',
  grip: 'M4 6h8M4 10h8',
  minus: 'M3.5 8h9',
  // The Length tools' small steps: a shorter stroke than their large ones.
  'minus-sm': 'M5.5 8h5',
  'plus-sm': 'M8 5.5v5M5.5 8h5',
  'chevs-up': 'm4 8 4-4 4 4M4 13l4-4 4 4',
  'ar-9-16': 'M5.5 2.5h5v11h-5z',
  scissors: 'M4.5 3a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3zM4.5 10a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3zM5.8 5.2 13 12.5M5.8 10.8 13 3.5',
  say: 'M2.5 3.5h11v7H8l-3 2.5v-2.5H2.5z',
  wave: 'M2.5 6.5v3M5 4.5v7M7.5 2.5v11M10 4.5v7M12.5 6.5v3',
  fit: 'M2 8h12M5 2.5v3.5M3.8 4.8 5 6l1.2-1.2M11 13.5V10M9.8 11.2 11 10l1.2 1.2',
  level: 'M2.5 11.5a5.5 5.5 0 1 1 11 0M8 11.5l2.8-3.6M4.1 8.4l.9.5M11.9 8.4l-.9.5M8 5.5v1',
  undo: 'M4 6.5h6a3 3 0 0 1 0 6H7M4 6.5 7 3.5M4 6.5 7 9.5',
  play: 'M5.5 3.5v9l7-4.5z',
  pause: 'M5.5 3.5v9M10.5 3.5v9',
  stop: 'M4.5 4.5h7v7h-7z',
  loop: 'M4.2 6.2a4.3 4.3 0 0 1 7.3-1.4M11.8 2.5v2.4H9.4M11.8 9.8a4.3 4.3 0 0 1-7.3 1.4M4.2 13.5v-2.4h2.4',
  'redo-arrow': 'M12 6.5H6a3 3 0 0 0 0 6h3M12 6.5 9 3.5M12 6.5 9 9.5',
  trim: 'M3.5 2.5v11M12.5 2.5v11M6 8h4M7.2 6.8 6 8l1.2 1.2M8.8 6.8 10 8l-1.2 1.2',
  eye: 'M1.5 8s2.5-4.5 6.5-4.5S14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8zM8 6.2a1.8 1.8 0 1 1 0 3.6a1.8 1.8 0 0 1 0-3.6z',
  'ar-1-1': 'M3.5 3.5h9v9h-9z',
  'ar-16-9': 'M2.5 5h11v6h-11z',
  'chevs-down': 'm4 3 4 4 4-4M4 8l4 4 4-4',
  pencil: 'M11.5 2.5l2 2L5.5 12.5l-2.9.9.9-2.9zM10 4l2 2',
  close: 'M4.2 4.2l7.6 7.6M11.8 4.2l-7.6 7.6',
  'chev-l': 'M9 4.5 5.5 8 9 11.5',
  'chev-r': 'M7 4.5 10.5 8 7 11.5',
  person: 'M8 2.8a2.6 2.6 0 1 1 0 5.2a2.6 2.6 0 0 1 0-5.2z M3.2 13.5a4.8 4.8 0 0 1 9.6 0',
  sfx: 'M8 1.8v2.7M8 11.5v2.7M1.8 8h2.7M11.5 8h2.7M3.9 3.9l1.9 1.9M10.2 10.2l1.9 1.9M12.1 3.9l-1.9 1.9M5.8 10.2l-1.9 1.9',
  mute: 'M2.5 6.3h2l3-2.5v8.4l-3-2.5h-2z M10.3 6.2 13.8 9.7M13.8 6.2l-3.5 3.5',
  reset: 'M3.6 6.4A5 5 0 1 1 3 8.6 M3 3.2v3.2h3.2',
  compose: 'M2 5h3.4v6H2z M6.3 5h3.4v6H6.3z M10.6 5h3.4v6h-3.4z',
  text: 'M2.5 3.5h7M6 3.5V12.5 M9.5 7.5h4M11.5 7.5v5',
  warn: 'M8 2.7 14.6 13.3H1.4z M8 6.8v3M8 11.5v.01',
};

/** The double sparkle, the same mark Netfox uses; fill, not stroke. */
export function Spark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true" className={className ?? 'spark'}>
      <path d="M6 4.5c.45 2.55 2.18 4.28 4.9 4.9-2.72.62-4.45 2.35-4.9 4.9-.45-2.55-2.18-4.28-4.9-4.9 2.72-.62 4.45-2.35 4.9-4.9z" />
      <path d="M11.75 1.5c.24 1.36 1.16 2.28 2.6 2.6-1.44.32-2.36 1.24-2.6 2.6-.24-1.36-1.16-2.28-2.6-2.6 1.44-.32 2.36-1.24 2.6-2.6z" />
    </svg>
  );
}

export function Icon({ name, className }: { name: string; className?: string }) {
  const d = PATHS[name] ?? '';
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true" className={className}>
      <path d={d} />
    </svg>
  );
}

export function Chevron({ up }: { up?: boolean }) {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true" className="chev">
      <path d={up ? 'm4 10 4-4 4 4' : 'm4 6 4 4 4-4'} />
    </svg>
  );
}

export function Tick() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true" className="tick">
      <path d="m3.5 8.5 3 3 6-7" />
    </svg>
  );
}

export function Bolt() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <path d="M9 1.5 3 9h4l-1 5.5L13 7H9z" />
    </svg>
  );
}

/** A five-point star, filled: a rating's mark. */
export function Star() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <path d="M8 1.6l1.95 4.1 4.5.55-3.3 3.1.85 4.45L8 11.6l-4 2.2.85-4.45-3.3-3.1 4.5-.55z" />
    </svg>
  );
}
